const Handlebars = require('handlebars')
const $ = require('jquery')

const dynamicContentComponent = {
  init () {
    this.$dynamicContentTemplate = $('.dynamic-content-template')
    this.$dynamicContentTemplate.each(function(i, val) {
      const _ = $(this)

      const Loader = function(typeSize, colorStyle) {
        return `<div id="dynamic_loader_${i}" class="loader__inner loader--${colorStyle} loader__inner--${typeSize}"><div class="water-splash"><div><span></span><span></span><span></span></div></div></div></div>`
      }

      _.after(Loader('small', 'blue'))

      const apiCall = `${_.attr('data-url')}?${_.attr('data-config')}`
      const theTemplate = Handlebars.compile(val.innerHTML)

      const loadData = function() {
        return $.ajax({
          url: apiCall,
          dataType: 'json',
          method: 'GET',
          success (data) {
            _.after(theTemplate(data))
          },
          complete () {
            $(`#dynamic_loader_${i}`).remove()
          },
        })
      }

      loadData()
    })
  },
}

module.exports = dynamicContentComponent



// WEBPACK FOOTER //
// ./src/modules/dynamicContentComponent.js